import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MyLog from './MyLogTable';
import MyInboxTable from "./MyInboxTable";
import PriorityAlertTable from "./PriorityAlertTable";
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import {Pie} from 'react-chartjs-2'
import EmailIcon from '@material-ui/icons/Email';
import PriorityHigh from '@material-ui/icons/PriorityHigh';
import Edit from '@material-ui/icons/Edit';
import NotificationImportant from '@material-ui/icons/NotificationImportant';

//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import { Divider, Hidden } from '@material-ui/core';


import Alertview from "./dashboard_alerts_tab";
import Taskview from "./dashboard_task_tab";

import config from "../../config/config";
import axios from 'axios';
import { grid_spacing, styles } from '../CSS/Styles';


function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const getState = () => ({
    datasets: [{
        data: [getRandomInt(50, 200), getRandomInt(100, 150), getRandomInt(150, 250)],
        backgroundColor: [
            '#CCC',
            '#36A2EB',
            '#FFCE56'
        ],
        hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
        ]
    }]
});
class Dashboard extends Component {
    constructor(props) {
		super(props);
        this.state = {
            value:0
        }
    }

    handleChange = (event, value) => {
         this.setState({ value });
    };

    getTasks(){
        axios.get(config.task)
        .then(res => {
            let tasks = res.data;
            let task_data = []
            task_data.push(tasks.filter(task=>task.status=='Draft').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Response').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Review').length)
            task_data.push(tasks.filter(task=>task.status=='Rejected').length)
            task_data.push(tasks.filter(task=>task.status=='Completed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Draft',
                'Pending Response',
                'Pending Review',
                'Rejected',
                'Completed'
                ],
                datasets:[{
                    data:task_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                taskStatusData: data
            })
        })
    }
    getAlerts(){
        axios.get(config.allAlerts)
        .then(res => {
            let alerts = res.data;
            let alert_data = []
            alert_data.push(alerts.filter(alert=>alert.status=='Open').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Investigating').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Review').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Approval For Closure').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Closed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Open',
                'Investigating',
                'Pending Review',
                'Pending Approval For Closure',
                'Closed'
                ],
                datasets:[{
                    data:alert_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                alertStatusData: data
            })
        })
    }
    getInitialState() {
        return getState();
    }

    componentDidMount(){
        this.getAlerts();
        this.getTasks();
    }

    componentWillMount() {
        this.setState(getState());
        setInterval(() => {
            // this.setState(getState());
            this.getAlerts();
            this.getTasks();
        }, 60000);
    }
    render() {
        const { classes } = this.props;
        const data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [
                {
                    label: 'DataSet',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: [65, 59, 80, 81, 56, 55, 40]
                }
            ]
        };
        const alertPie = <Pie data={this.state.alertStatusData} style={{height:""}}/>
        const taskPie = <Pie data={this.state.taskStatusData}/>
        const loading = <span>loading data</span>

        const alertpiemerge = (                    
            <Grid item md={6}>
                <Card style={{ height: "65vh" }}>
                    <CardActionArea className={classes.cardAction}>
                        <CardContent>
                            <Typography variant="headline">
                                Alert
                            </Typography>
                            {this.state.alertStatusData? alertPie:loading}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
        )

        const taskpiemerge = (                    
            <Grid item md={6}>
                <Card style={{ height: "65vh" }}>
                    <CardActionArea className={classes.cardAction}>
                        <CardContent>
                            <Typography variant="headline">
                                Task
                            </Typography>
                            {this.state.alertStatusData? taskPie:loading}
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
        )

        const dashBoardTabTable = (
            <div>
                <Tabs
                    className={classes.actions}
                    value={this.state.value}
                    fullWidth={true}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}

                >
                    <Tab label={
                        <Badge /*color="secondary" className={classes.padding} badgeContent={13}*/ >
                            Alert
                        </Badge>
                    } />
                    <Tab label={
                        <Badge /*color="secondary" className={classes.padding} badgeContent={13}*/ >
                            Task List
                        </Badge>
                    } />
                </Tabs>
                <Divider />
                    {this.state.value == 0 ? <Alertview piechart = {alertpiemerge}/>: null}

                    {this.state.value === 1 ? <Taskview piechart = {taskpiemerge}/> : null}

                <Divider />
            </div>
        )


        return (
            <div>
                <Grid container spacing={grid_spacing}>
                    <Grid item xs={3}>
                        <Card className={classes.card}>
                            <CardActionArea className={classes.cardAction}>
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography variant="headline">103</Typography>
                                        <Typography variant="subheading" color="textSecondary">
                                            NEW
                                        </Typography>
                                    </CardContent>
                                </div>
                                <CardMedia
                                    image={<EmailIcon />}
                                    h6="Live from space album cover"
                                />
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item md={3}>
                        <Card className={classes.card}>
                            <CardActionArea className={classes.cardAction}>
                                <CardContent>
                                    <Typography variant="headline">12</Typography>
                                    <Typography variant="subheading" color="textSecondary">
                                        IN PROGRESS
                                        </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item md={3}>
                        <Card className={classes.card}>
                            <CardActionArea className={classes.cardAction}>
                                <CardContent>
                                    <Typography variant="headline">3</Typography>
                                    <Typography variant="subheading" color="textSecondary">
                                        ESCALATED
                                        </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item md={3}>
                        <Card className={classes.card}>
                            <CardActionArea className={classes.cardAction}>
                                <CardContent>
                                    <Typography variant="headline">26</Typography>
                                    <Typography variant="subheading" color="textSecondary">
                                        OVERDUE
                                        </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>

                    <Grid item md={12}>
                        {dashBoardTabTable}
                    </Grid>

{/*                    <Grid item md={6}>
                        <Card style={{ height: "60vh" }}>
                            <CardActionArea className={classes.cardAction}>
                                <CardContent>
                                    <Typography variant="headline">
                                        Alert
                                    </Typography>
                                    {this.state.alertStatusData? alertPie:loading}
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item md={6}>
                        <Card style={{ height: "60vh" }}>
                            <CardActionArea className={classes.cardAction}>
                                <CardContent>
                                    <Typography variant="headline">
                                        Task
                                    </Typography>
                                    {this.state.alertStatusData? taskPie:loading}
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>*/}
{/*                    <Grid item md={8}>
                        <Card style={{ height: "50vh" }}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                        <NotificationImportant />
                                    </Avatar>
                                }

                                h6="Alert Summary By Risk"
                            />
                            <CardContent>
                                <Grid container>
                                    <Grid item md={4}>
                                        <Doughnut data={this.state} />
                                    </Grid>
                                    <Grid item md={4}>
                                        <Doughnut data={this.state} />
                                    </Grid>
                                    <Grid item md={4}>
                                        <Doughnut data={this.state} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                    </Grid>
                    <Grid item md={4}>
                        <Card style={{ height: "50vh" }}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                        <PriorityHigh />
                                    </Avatar>
                                }

                                h6="Priority Alerts"
                            />
                            <CardContent>
                                <PriorityAlertTable />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={8}>
                        <Card style={{ height: "50vh" }}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                        <Edit />
                                    </Avatar>
                                }

                                h6="My Log"
                            />
                            <CardContent>
                                <MyLog />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={4}>
                        <Card style={{ height: "50vh" }}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                        <EmailIcon />
                                    </Avatar>
                                }

                                h6="My Inbox"
                            />
                            <CardContent>
                                <MyInboxTable />
                            </CardContent>
                        </Card>
                    </Grid>*/}
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardNew.js